<template>
  <div class="main-content-container mb-5">
    <div class="top-content-container">
      <b-row>
        <b-col md="12">
          <b-breadcrumb class="customer-breadcrumbs">
            <b-breadcrumb-item
              @click="navigateToCustomersList"
              v-if="$route.meta.customers"
            >
              <span class="text-uppercase font-family-medium">
                Customers
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item
              @click="navigateToCustomerDetails"
              v-if="$route.meta.customers"
            >
              <span class="text-uppercase font-family-medium">
                {{ customerFullName }}
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item v-if="$route.meta.tasks">
              <span
                @click="navigateToTasks"
                class="text-uppercase font-family-medium"
              >
                Tasks
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item>
              <span
                class="text-uppercase font-family-medium"
                @click="navigateToWeekly"
              >
                Weekly
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <span class="text-uppercase font-family-medium">
                View Weekly
              </span>
            </b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <!-- <b-col md="3" class="d-flex justify-content-end align-items-end">

        </b-col> -->
      </b-row>
      <b-row class="mt-4">
        <b-col
          cols="12"
          lg="9"
          class="customer-dropdown-column"
          :style="{ paddingRight: '15px' }"
        >
          <ValidationObserver ref="selectedCustomer">
            <ValidationProvider name="selectedCustomer" rules="required">
              <b-form-group
                v-if="!isLoadingCustomers"
                label="Customer *"
                class="weekly-form-group"
              >
                <b-form-select
                  class="position-relative customer-select"
                  v-if="!isLoadingCustomers"
                  :options="eligibleCustomersList"
                  :disabled="btnDisabled"
                  @change="getSelectedCustomer"
                  v-model="selectedCustomer"
                >
                </b-form-select>
                <h6
                  v-if="selectedCustomerValid === false"
                  class="font-sm font-family-regular danger ml-2 position-absolute"
                >
                  This field is required
                </h6>
              </b-form-group>
            </ValidationProvider>
          </ValidationObserver>
        </b-col>
      </b-row>
      <b-row class="d-flex align-items-center">
        <b-col class="" cols="12" lg="9">
          <ValidationObserver ref="title">
            <ValidationProvider
              name="Title"
              rules="required"
              v-slot="{ errors }"
            >
              <b-form-group label="Title *" class="weekly-form-group">
                <b-form-input
                  type="text"
                  :disabled="btnDisabled"
                  @change="onTitleChange"
                  v-model="title"
                  placeholder="Add title of weekly"
                ></b-form-input>
                <div
                  v-if="errors[0]"
                  class="font-sm font-family-regular danger position-absolute"
                >
                  This field is required
                </div>
              </b-form-group>
            </ValidationProvider>
          </ValidationObserver>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col class="" cols="12" lg="9">
          <ValidationObserver>
            <ValidationProvider name="rte" rules="required">
              <p class="font-family-medium">Description *</p>
              <quill-editor
                ref="quillEditor"
                class="quill-custom weekly-desc"
                :disabled="btnDisabled"
                v-model="content"
                :options="editorOptions"
              />
              <input
                ref="imageInput"
                class="d-none"
                type="file"
                accept="image/*"
                @change="_doImageUpload"
              />
              <h6
                v-if="contentValid === false"
                style="margin-bottom: -2rem"
                class="font-sm font-family-regular danger ml-2 mt-4"
              >
                Description is required
              </h6>
            </ValidationProvider>
          </ValidationObserver>
        </b-col>
      </b-row>
      <b-row v-if="showAlert">
        <b-col md="12" class="position-relative">
          <b-alert
            class="alert-btn-top custom-alert ml-3"
            :show="showAlert"
            :fade="true"
            >{{ alertMsg }}</b-alert
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            @click="deleteModal.visible = true"
            :disabled="btnDisabled"
            class="btn-pill py-3 px-5 mb-5 mt-3 btn-danger">
            Delete
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-modal
      centered
      body-class="delete-modal"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="deleteModal.visible"
    >
      <b-container fluid>
        <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt @click="deleteModal.visible = false"/>
        <b-row
          class="pt-2 mb-5 d-flex flex-column"
          :style="{ paddingLeft: '15px' }"
        >
          <h2
            class="modal_header font-md"
            :style="{ marginBottom: 0 }"
          >
            Are you sure?
          </h2>
          <h4  class="font-md subtext">
            Do you want to delete this weekly task?
          </h4>
        </b-row>
        <b-row align-v="center">
          <b-button
            :style="{ marginLeft: 'auto' }"
            @click="deleteWeeklyTask"
            :disabled="deleting"
            class="btn-danger px-5 py-3 mr-5 btn-pill reduce-whitespace"
          >
            <b-spinner
              v-if="deleting"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            <template v-else> Delete </template>
          </b-button>
        </b-row>
      </b-container>
    </b-modal>
    <SaveIndicator ref='saveIndicator'/>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import SaveIndicator from '@/components/indicators/SaveIndicator'
import { quillEditor } from "vue-quill-editor";
import { getAssistantCustomers, getCustomerDetails } from "@/apis/customers";
import { deleteWeeklyNotes, getNoteDetails, patchWeeklyNotes } from "@/apis/assistants";
import { editorOptions, DEBOUNCE_DELAY } from '@/utils/constants'
import {
  ValidationObserver,
  ValidationProvider
} from "vee-validate/dist/vee-validate.full";
import { mapState } from "vuex";
import _ from 'lodash';

export default {
  name: "ViewEditWeeklyTasks",
  components: {
    quillEditor,
    ValidationObserver,
    SaveIndicator,
    ValidationProvider
  },
  data() {
    return {
      customerFullName: "",
      content: "",
      saveBtnText: "Save",
      loaded: false,
      isLoading: false,
      isLoadingCustomers: true,
      deleteModal: {
        visible: false
      },
      deleting: false,
      title: "",
      assistantProfileId: "",
      eligibleCustomersList: [{ text: "Select customer name", value: null }],
      selectedCustomer: null,
      editorOptions,
      titleValid: null,
      contentValid: null,
      selectedCustomerValid: null,
      showAlert: false
    };
  },
  computed: {
    quillInstance() {
      return this.$refs.quillEditor.quill;
    },
    btnDisabled() {
      return this.isLoading;
    },
    ...mapState("authModule", ["role"])
  },
  created() {
    if (this.$route.params.name) {
      this.customerFullName = this.$route.params.name;
    } else if (this.$route.meta.customers) {
      getCustomerDetails(this.$route.params.profileId)
        .then(res => {
          let { firstName, lastName } = res.data.user;
          this.customerFullName = `${firstName} ${lastName}`;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.assistantProfileId = this.$route.params.assistantId;
    getNoteDetails(this.assistantProfileId, this.$route.params.notesId)
      .then(res => {
        let { notes, title, participent } = res.data;
        this.content = notes;
        this.title = title;
        this.selectedCustomer = participent.id;
        this.$nextTick(() => {
          this.$refs.quillEditor.$on('change', this.onEditorChange)
        })
      })
      .then(() => {
        getAssistantCustomers(this.assistantProfileId, {})
          .then(res => {
            this.eligibleCustomersList = [...res.data.results]
            .filter(customer => customer.customer.profile)
            .map(item => {
              return {
                text: `${item.customer.profile.user.firstName} ${item.customer.profile.user.lastName}`,
                value: item.customer.profile.id
              };
            });
            this.eligibleCustomersList.unshift({
              value: null,
              text: "Select customer name"
            });
            this.loaded = true
          })
          .catch(err => {
            console.log(err);
          });
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.isLoadingCustomers = false;
      });
      this.onTitleChange = _.debounce(this.onTitleChange, DEBOUNCE_DELAY)
      this.onEditorChange = _.debounce(this.onEditorChange, DEBOUNCE_DELAY)
      this.getSelectedCustomer = _.debounce(this.getSelectedCustomer, DEBOUNCE_DELAY)
      this.showSaveIndicator = this.$refs.saveIndicator.showSaveIndicator
      this.showSaveIndicatorSaved = this.$refs.saveIndicator.showSaveIndicatorSaved
      this.showSaveIndicatorError = this.$refs.saveIndicator.showSaveIndicatorError
  },
  methods: {
    navigateToCustomersList() {
      this.$router.push({
        name: "DedicatedCustomers"
      });
    },
    async deleteWeeklyTask() {
      this.deleting = true
      try {
        await deleteWeeklyNotes(this.assistantProfileId, this.$route.params.notesId)
        this.$router.go(-1)
      } catch(e) {
        console.log(e)
        this.showSaveIndicatorError()
      } finally {
        this.deleting = false
      }
    },
    navigateToCustomerDetails() {
      this.$router.push({
        name: "CustomerDetails",
        params: {
          profileId: this.selectedCustomer
        },
        query: {
          tab: 2
        }
      });
    },
    navigateToTasks() {
      if (this.$route.name === "ViewWeeklyTaskCustomer") {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: this.$route.params.profileId
          },
          query: {
            tab: 0
          }
        });
      } else if (this.$route.name === "ViewWeeklyTask") {
        this.$router.push({
          name: "TaskDashboard"
        });
      }
    },
    navigateToWeekly() {
      console.log(this.$route.name);
      if (this.$route.name === "ViewWeeklyTaskCustomer") {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: this.$route.params.profileId
          },
          query: {
            tab: 3
          }
        });
      } else if (this.$route.name === "ViewWeeklyTask") {
        if (this.role === "assistant") {
          this.$router.push({
            name: "PAWeeklyTasks",
            params: {
              profileId: this.$route.params.assistantId
            }
          });
        } else if (this.role === "admin") {
          this.$router.push({ name: "AllWeeklyTasks" });
        }
      }
    },
    getSelectedCustomer() {
      if (this.selectedCustomer) {
        this.selectedCustomerValid = true;
        this.patchWeeklyTask({
          participent: this.selectedCustomer
        })
      } else {
        this.selectedCustomerValid = false;
      }
    },
    async patchWeeklyTask(payload) {
      let { notesId } = this.$route.params
      this.showSaveIndicator()
      try {
        await patchWeeklyNotes(this.assistantProfileId, {
          ...payload,
          organizer: this.assistantProfileId
        }, notesId)
        this.showSaveIndicatorSaved()
      } catch(e) {
        console.log(e)
        this.showSaveIndicatorError()
      }
    },
    onTitleChange() {
      if (this.title.length > 0) {
        this.patchWeeklyTask({
          title: this.title
        })
      }
    },
    onEditorChange() {
      if (!this.loaded) {
        return
      }
      let strippedContent = this.content.replace(/<(.|\n)*?>/g, "").trim();

      const imgRegex = /<img[^>]*>/g;

      // Check if the html entered in the editor has images.
      // Add dummy text to strippedContent to prevent validation error
      // when only an image is uploaded, no text
      if (
        this.content.match(imgRegex) &&
        this.content.match(imgRegex).length > 0 &&
        strippedContent.length === 0
      ) {
        strippedContent = "a";
      }

      if (strippedContent.length === 0) {
        this.contentValid = false;
      } else {
        this.contentValid = true;
        this.patchWeeklyTask({
          notes: this.content      
        })
      }
    },
    showImageUI() {
      this.$refs.imageInput.click();
    },
    async _doImageUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      let previewImage;
      reader.onload = e => {
        previewImage = e.target.result;
        // get current index of the cursor
        const currentIndex = this.quillInstance.selection.lastRange.index;
        // insert uploaded image url to 'image' embed (quill does this for you)
        // the embed looks like this: <img src="{url}" />
        this.quillInstance.insertEmbed(currentIndex, "image", previewImage);
        // set cursor position to after the image
        this.quillInstance.setSelection(currentIndex + 1, 0);
      };
    },
    updateNotes() {
      this.$refs.title
        .validate()
        .then(val => {
          this.titleValid = val;
        })
        .then(() => {
          if (this.selectedCustomer === null) {
            this.selectedCustomerValid = false;
          } else if (this.selectedCustomer !== null) {
            this.selectedCustomerValid = true;
          }
          let strippedContent = this.content.replace(/<(.|\n)*?>/g, "").trim();

          const imgRegex = /<img[^>]*>/g;

          // Check if the html entered in the editor has images.
          // Add dummy text to strippedContent to prevent validation error
          // when only an image is uploaded, no text
          if (
            this.content.match(imgRegex) &&
            this.content.match(imgRegex).length > 0 &&
            strippedContent.length === 0
          ) {
            strippedContent = "a";
          }

          if (strippedContent.length === 0) {
            this.contentValid = false;
          } else {
            this.contentValid = true;
          }
        })
        .finally(() => {
          if (
            this.titleValid &&
            this.selectedCustomerValid &&
            this.contentValid
          ) {
            this.isLoading = true;

            const payload = {
              title: this.title,
              notes: this.content,
              participent: this.selectedCustomer,
              organizer: this.assistantProfileId
            };
            patchWeeklyNotes(
              this.assistantProfileId,
              payload,
              this.$route.params.notesId
            )
              .then(() => {
                this.showAlert = true;
                this.alertMsg = "Saved note successfully!";
                this.$router.go(-1);
              })
              .catch(err => {
                this.showAlert = true;
                if (err.response.status === 401) {
                  this.alertMsg =
                    "User token expired. Please logout and login again";
                } else {
                  this.alertMsg = "Some error occured";
                }
                console.log(err);
                this.isLoading = false;
              })
              .finally(() => {
                this.isLoading = false;
              });
          } else if (
            !this.titleValid ||
            !this.selectedCustomerValid ||
            !this.contentValid
          ) {
            this.showAlert = true;
            this.alertMsg = "There are invalid form fields";
          }
        });
    }
  }
};
</script>

<style scoped lang="scss">
.customer-select {
  top: 0rem;
}
.custom-caret {
  position: absolute;
  right: 1rem;
  top: 2.2rem;
  z-index: 52;
}
fieldset.form-group {
  margin-bottom: 3rem;
}
.customer-dropdown-column {
  justify-content: flex-end;

  @media (max-width: 767px) {
    justify-content: flex-start;
  }
}
.close-icon {
  right: -2.2rem;
  top: -2rem;
  position: absolute;
  cursor: pointer;
  background: none;
}
::v-deep div.delete-modal {
  padding-bottom: 2rem;
}
</style>
